import React, { useEffect, useState } from 'react';
import { PageProps } from '../../Handbooks.types';
import { Styled } from '../../Handbooks.styles';
import { useRouteMatch } from 'react-router';
import { IconButton } from 'office-ui-fabric-react';

export const Pager: React.FC<PageProps> = (props: PageProps) => {
  return (
    <Styled.Pager>
      <IconButton
        onClick={() => props.onPageChanged(props.currentPage-1)}
        iconProps={{ iconName: 'ChevronLeft' }}
        disabled={props.currentPage <= 1}
      />
      <span>{props.currentPage}</span>&nbsp;из&nbsp;
      <span>{props.pageCount}</span>
      <IconButton
        onClick={() => props.onPageChanged(props.currentPage+1)}
        iconProps={{ iconName: 'ChevronRight' }}
        disabled={props.currentPage >= props.pageCount}
      />
    </Styled.Pager>
  );
};
